import { render } from "./DepartmentProfile.vue?vue&type=template&id=345f21d6"
import script from "./DepartmentProfile.vue?vue&type=script&lang=js"
export * from "./DepartmentProfile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\E-TICKET\\eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__